"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _filter = _interopRequireDefault(require("lodash/filter"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _map = _interopRequireDefault(require("lodash/map"));
var _mean = _interopRequireDefault(require("lodash/mean"));
var _simplePeer = _interopRequireDefault(require("@amplement/simple-peer"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var actions = _interopRequireWildcard(require("../resources/webRTC/actions"));
var _debug = require("./debug");
var _streams = require("./streams");
var _constants = require("../resources/webRTC/constants");
var _constants2 = require("../resources/network/constants");
var _constants3 = require("../resources/websocket/constants");
var _callbacks = _interopRequireDefault(require("../callbacks"));
var _config = _interopRequireDefault(require("../config"));
var _errorHandler = _interopRequireDefault(require("./errorHandler"));
var _logger = _interopRequireDefault(require("./logger"));
var _manager = _interopRequireDefault(require("../resources/websocket/manager"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // TODO remove WEBRTC
var logger = new _logger.default('utils:PeerManager');
var stateValues = {
  new: _constants.WEBRTC_STATES.INIT,
  checking: _constants.WEBRTC_STATES.CONNECTING,
  completed: _constants.WEBRTC_STATES.CONNECTED,
  connected: _constants.WEBRTC_STATES.CONNECTED,
  failed: _constants.WEBRTC_STATES.FAILED,
  closed: _constants.WEBRTC_STATES.CLOSED,
  disconnected: _constants.WEBRTC_STATES.DISCONNECTED
};
var getStreamTrackState = stream => {
  var trackState = {
    audio: false,
    video: false
  };
  if (!stream) return trackState;
  var tracks = stream.getTracks();
  tracks.forEach(t => {
    if (t.enabled && !t.muted) {
      trackState[t.kind] = true;
    }
  });
  return trackState;
};
class Peer {
  constructor(_ref) {
    var _this = this;
    var {
      token: _token,
      settings: _settings,
      _entity,
      _client,
      profile
    } = _ref;
    _defineProperty(this, "_peer", undefined);
    _defineProperty(this, "_token", undefined);
    _defineProperty(this, "_profile", undefined);
    _defineProperty(this, "__entity", undefined);
    _defineProperty(this, "__client", undefined);
    _defineProperty(this, "_hasVideo", {});
    _defineProperty(this, "_hasVideoAttempts", {});
    _defineProperty(this, "_hasAudio", {});
    _defineProperty(this, "_settings", {});
    _defineProperty(this, "_defaultSettings", {
      isInitiator: false,
      stream: undefined
    });
    _defineProperty(this, "_state", _constants.WEBRTC_STATES.INIT);
    _defineProperty(this, "_stateAt", Date.now());
    _defineProperty(this, "_reconnectInterval", undefined);
    _defineProperty(this, "_isReconnecting", false);
    _defineProperty(this, "_maxReconnectAttempts", 5);
    _defineProperty(this, "_remotePeerId", undefined);
    _defineProperty(this, "_reconnectAttempt", 0);
    _defineProperty(this, "_reconnectAttemptsThreshold", [1000, 3000, 5000, 8000, 10000, 15000, 30000]);
    _defineProperty(this, "_monitoringInterval", {});
    _defineProperty(this, "_streamChangedAt", 0);
    _defineProperty(this, "_stats", {});
    _defineProperty(this, "_rtt", []);
    _defineProperty(this, "_networkQuality", void 0);
    _defineProperty(this, "log", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return logger.log(...args, _this._token);
    });
    _defineProperty(this, "warn", function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return logger.warn(...args, _this._token);
    });
    _defineProperty(this, "error", function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return logger.error(...args, _this._token);
    });
    _defineProperty(this, "debug", function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return logger.debug(...args, _this._token);
    });
    _defineProperty(this, "_createPeer", () => {
      var _stream$getAudioTrack, _stream$getVideoTrack, _stream$getTracks;
      var {
        _token: token,
        _defaultSettings: defaultSettings,
        _settings: overridedSettings
      } = this;
      var genericInfo = {
        _entity: this.__entity,
        token: this._token,
        _client: this.__client
      };
      var settings = _objectSpread(_objectSpread({}, defaultSettings), overridedSettings);
      var {
        isInitiator,
        stream
      } = settings;
      var hasTracks = stream && !!stream.getTracks().length;
      var answerOptions = {
        offerToReceiveAudio: !isInitiator,
        offerToReceiveVideo: !isInitiator
      };
      var offerOptions = {
        offerToReceiveAudio: isInitiator && !!(stream !== null && stream !== void 0 && (_stream$getAudioTrack = stream.getAudioTracks) !== null && _stream$getAudioTrack !== void 0 && (_stream$getAudioTrack = _stream$getAudioTrack.call(stream)) !== null && _stream$getAudioTrack !== void 0 && _stream$getAudioTrack.length),
        offerToReceiveVideo: isInitiator && !!(stream !== null && stream !== void 0 && (_stream$getVideoTrack = stream.getVideoTracks) !== null && _stream$getVideoTrack !== void 0 && (_stream$getVideoTrack = _stream$getVideoTrack.call(stream)) !== null && _stream$getVideoTrack !== void 0 && _stream$getVideoTrack.length)
      };
      var trickle = true;

      // for dev to locally force relay usage
      // settings.RTCConfiguration.iceTransportPolicy = 'relay';
      var conf = {
        id: token,
        answerOptions,
        voiceActivityDetection: true,
        config: settings === null || settings === void 0 ? void 0 : settings.RTCConfiguration,
        initiator: isInitiator,
        objectMode: true,
        offerOptions,
        reconnectTimer: 5000,
        stream: hasTracks ? stream : null,
        trickle,
        withDataChannel: false,
        wrtc: _callbacks.default.get('getWebRTC')(),
        sdpTransform: sdp => {
          var _config$webRTC, _this$_profile, _this$_profile2, _this$_profile3;
          if ((_config.default === null || _config.default === void 0 || (_config$webRTC = _config.default.webRTC) === null || _config$webRTC === void 0 || (_config$webRTC = _config$webRTC.bitrates) === null || _config$webRTC === void 0 ? void 0 : _config$webRTC.enable) === false) return sdp;
          var newSdp = sdp;
          var videoBitrate = ((_this$_profile = this._profile) === null || _this$_profile === void 0 ? void 0 : _this$_profile.screenSharingBitrate) || ((_this$_profile2 = this._profile) === null || _this$_profile2 === void 0 ? void 0 : _this$_profile2.videoBitrate);
          var audioBitrate = (_this$_profile3 = this._profile) === null || _this$_profile3 === void 0 ? void 0 : _this$_profile3.audioBitrate;
          var trackState = getStreamTrackState(stream);
          var isSetMediaBitrateExist = _callbacks.default.isExist('setMediaBitrate');
          var isTransform = false;
          if (videoBitrate && trackState.video && isSetMediaBitrateExist) {
            newSdp = _callbacks.default.get('setMediaBitrate')(newSdp, 'video', videoBitrate);
            isTransform = true;
          }
          if (audioBitrate && trackState.audio && isSetMediaBitrateExist) {
            newSdp = _callbacks.default.get('setMediaBitrate')(newSdp, 'audio', audioBitrate);
            isTransform = true;
          }
          if (isTransform) {
            this.log('sdp Transform', _objectSpread(_objectSpread({}, genericInfo), {}, {
              profile: this._profile,
              audioBitrate,
              videoBitrate,
              sdp: newSdp
            }));
          }
          return newSdp;
        }
      };
      this.log('create peer: with config', conf.config);
      var p = new _simplePeer.default(conf);
      this.log('create peer: pc details', {
        peerId: p._id,
        _reconnectAttempt: this._reconnectAttempt,
        stream,
        tracks: stream === null || stream === void 0 || (_stream$getTracks = stream.getTracks) === null || _stream$getTracks === void 0 ? void 0 : _stream$getTracks.call(stream),
        hasTracks
      });
      this._streamChangedAt = Date.now();
      this.startMonitoringStream(stream);
      p.on('error', error => {
        _errorHandler.default.captureException(error, 'SimplePeer:onError', genericInfo);
        if (!this._isReconnecting) {
          this._isReconnecting = true;
          _callbacks.default.get('dispatch')(actions.onPeerConnectionError(_objectSpread(_objectSpread({}, genericInfo), {}, {
            error: error.code
          })));
        }
        this.stopMonitoringAllStreams();
      });
      p.on('connect', () => {
        this.log('on connect', isInitiator, p._id);
        this._reconnectAttempt = 0;
        // Callbacks.get('dispatch')(actions.onPeerConnectionConnect({ ...genericInfo }));

        // HACK: send through data channel the audio/video activation.
        // Should be removed if mechanism based on track
        var trackState = getStreamTrackState(stream);
        p.send(JSON.stringify(trackState));
      });
      p.on('signal', data => {
        if (data.candidate && data.candidate.candidate) {
          var _webSocketManager$get;
          this.log('on signal: ice candidate', data.candidate.candidate, isInitiator, p._id);
          (_webSocketManager$get = _manager.default.getWs(_constants3.WEBSOCKET_NAME)) === null || _webSocketManager$get === void 0 || _webSocketManager$get.send({
            code: "WRTC_ICE_CANDIDATES",
            payload: {
              _entity: this.__entity,
              token,
              candidates: [data.candidate]
            }
          });

          // Stop gathering prematurely at the first "relay" candidate
          // to make ICE establishment faster in case of long list of STUN/TURN iceServers
          // and avoid requesting more than one TURN server
          // ICE resolution order: 1) host 2) srfx/prfx 3) relay
          var enableEndingTrickleOnFirstRelay = true;
          var isIceGathering = !p._iceComplete;
          var isRelayCandidate = data.candidate.candidate.indexOf('typ relay') !== -1;
          if (isIceGathering && isRelayCandidate && enableEndingTrickleOnFirstRelay) {
            this.log('on signal: ice candidate stop gathering because a first relay response has answered', data.candidate.candidate, isInitiator, p._id);

            // stop gathering by sending "end-of-candidates"
            // webSocketManager.getWs(WEBSOCKET_NAME)?.send({
            //     code: `WRTC_ICE_CANDIDATES`,
            //     payload: {
            //         _entity: this.__entity,
            //         token,
            //         candidates: [{ candidate: '', sdpMLineIndex: 0, sdpMid: '0' }],
            //     },
            // });
            // mandatory to stop ICE with simplePeer
            p._iceComplete = true;
            p.trickle = false;
          } else {
            logger.log('on signal:ice candidate sent to black hole because a relay response has already been found', data.candidate.candidate, token, p._id);
          }
        } else if (data.candidate && !data.candidate.candidate) {
          // notify remote peer that gathering is finished to faster the end of establishment
          // by generating a "end-of-candidates"
          // https://www.rfc-editor.org/rfc/rfc8838#name-receiving-an-end-of-candida
          this.log('on signal: ice candidate empty candidate received', data.candidate, isInitiator, p._id);
          // const candidates = [{ candidate: '', sdpMLineIndex: 0, sdpMid: '0' }];
          // webSocketManager.getWs(WEBSOCKET_NAME)?.send({
          //     code: `WRTC_ICE_CANDIDATES`,
          //     payload: {
          //         _entity: this.__entity,
          //         token: this._token,
          //         candidates,
          //     },
          // });
          // this.log(
          //     'on signal: ice candidate, notify remote about end of candidates',
          //     candidates,
          //     isInitiator,
          //     p._id,
          // );
        } else if ((data === null || data === void 0 ? void 0 : data.type) === 'answer') {
          var _webSocketManager$get2;
          this.log("on signal: answer created", isInitiator, p._id);
          (_webSocketManager$get2 = _manager.default.getWs(_constants3.WEBSOCKET_NAME)) === null || _webSocketManager$get2 === void 0 || _webSocketManager$get2.send({
            code: "WRTC_SDP_ANSWER",
            payload: {
              _entity: this.__entity,
              token,
              jsep: data
            }
          });
        } else if ((data === null || data === void 0 ? void 0 : data.type) === 'offer') {
          var _webSocketManager$get3;
          this.log("on signal: offer created", isInitiator, p._id);
          (_webSocketManager$get3 = _manager.default.getWs(_constants3.WEBSOCKET_NAME)) === null || _webSocketManager$get3 === void 0 || _webSocketManager$get3.send({
            code: "WRTC_SDP_OFFER",
            payload: {
              _entity: this.__entity,
              token,
              jsep: data
            }
          });
        } else {
          this.warn('on signal: skip unknown data', data, this.__client, this.__entity);
        }
      });
      p.on('stream', remoteStream => {
        this.log('on stream', remoteStream && remoteStream.getTracks(), isInitiator);
        this._streamChangedAt = Date.now();
        _callbacks.default.get('dispatch')(actions.onPeerConnectionStream(_objectSpread(_objectSpread({}, genericInfo), {}, {
          stream: remoteStream,
          isTrashable: this._settings.isTrashable,
          profile: this._profile
        })));
        this.startMonitoringStream(remoteStream);
      });
      p.on('track', (remoteTrack, remoteStream) => {
        _callbacks.default.get('dispatch')(actions.onPeerConnectionTrack(_objectSpread(_objectSpread({}, genericInfo), {}, {
          remoteTrack,
          remoteStream
        })));
      });
      p.on('data', data => {
        this.log('on data: ', data, isInitiator);
        _callbacks.default.get('dispatch')(actions.onPeerConnectionData(_objectSpread(_objectSpread({}, genericInfo), {}, {
          data
        })));
      });
      p.on('close', () => {
        this.log('on close', isInitiator);
        this.stopMonitoringAllStreams();
        _callbacks.default.get('dispatch')(actions.onPeerConnectionClose(_objectSpread({}, genericInfo)));
      });
      p.on('_iceComplete', () => {
        this.log('_iceComplete', isInitiator);
        // this._state = stateValues.completed;
        // this._stateAt = Date.now();
        // Callbacks.get('dispatch')(
        //     actions.onPeerConnectionIceStateChange({
        //         ...genericInfo,
        //         iceConnectionState: 'completed',
        //         iceGatheringState: 'complete',
        //         isTrashable: this._settings.isTrashable,
        //     }),
        // );
        // Callbacks.get('dispatch')(
        //     actions.onPeerConnectionSignal({ ...genericInfo, data: { candidate: [] } }),
        // );
      });

      p.on('iceStateChange', (iceConnectionState, iceGatheringState) => {
        this.log('on iceStateChange', {
          currentState: this._state,
          isInitiator,
          iceConnectionState,
          iceGatheringState
        });
        this._state = stateValues[iceConnectionState];
        this._stateAt = Date.now();
        _callbacks.default.get('dispatch')(actions.onPeerConnectionIceStateChange(_objectSpread(_objectSpread({}, genericInfo), {}, {
          iceConnectionState,
          iceGatheringState,
          isTrashable: this._settings.isTrashable
        })));
      });
      p._pc.onicecandidateerror = event => {
        var {
          errorCode,
          errorText,
          port,
          path,
          type,
          url,
          address
        } = event;
        if ((errorText === null || errorText === void 0 ? void 0 : errorText.indexOf('allocate request timed out.')) !== -1 || (errorText === null || errorText === void 0 ? void 0 : errorText.indexOf('Error: icecandidateerror')) !== -1) {
          _callbacks.default.get('dispatch')(actions.onPeerConnectionIceError(_objectSpread(_objectSpread({}, genericInfo), {}, {
            error: event
          })));
          _errorHandler.default.captureException(new Error((event === null || event === void 0 ? void 0 : event.errorText) || 'icecandidateerror'), 'SimplePeer:pc:onicecandidateerror', {
            genericInfo,
            event: {
              errorCode,
              errorText,
              port,
              path,
              type,
              url,
              address
            }
          });
        }
      };
      return p;
    });
    _defineProperty(this, "isChannelReady", () => (this.getPeer() || {})._channelReady);
    _defineProperty(this, "getPeer", () => this._peer);
    _defineProperty(this, "setRemoteId", _peerId => {
      this._remotePeerId = _peerId;
    });
    _defineProperty(this, "getRemoteId", () => this._remotePeerId);
    _defineProperty(this, "getVideoBitrate", () => {
      var _this$_profile4;
      return (_this$_profile4 = this._profile) === null || _this$_profile4 === void 0 ? void 0 : _this$_profile4.videoBitrate;
    });
    _defineProperty(this, "getScreenSharingBitrate", () => {
      var _this$_profile5;
      return (_this$_profile5 = this._profile) === null || _this$_profile5 === void 0 ? void 0 : _this$_profile5.screenSharingBitrate;
    });
    _defineProperty(this, "getAttemptTimeout", () => {
      if (this._reconnectAttempt < this._reconnectAttemptsThreshold.length) {
        // eslint-disable-line

        return this._reconnectAttemptsThreshold[this._reconnectAttempt]; // eslint-disable-line
      }

      return null;
    });
    _defineProperty(this, "_command", command => data => {
      if (data && !data.candidate) {
        this.log("".concat(command).concat(this._peer ? '' : '.skip'), data);
      } else {
        this.debug("".concat(command, ":ice").concat(this._peer ? '' : '.skip'), data);
      }
      if (this._peer) {
        this._peer[command](data);
      }
    });
    _defineProperty(this, "signal", this._command('signal'));
    _defineProperty(this, "write", this._command('write'));
    _defineProperty(this, "send", this._command('send'));
    _defineProperty(this, "close", err => {
      this.stopMonitoringAllStreams();
      this._command('destroy')(err);
      this._peer = null;
      this._state = _constants.WEBRTC_STATES.CLOSED;
      this._stateAt = Date.now();
    });
    _defineProperty(this, "reconnect", () => {
      var needReconnect = this._reconnectAttempt < this._maxReconnectAttempts;
      this.log("Reconnect".concat(needReconnect ? '' : '.skip', " target(%s) isInitiator(%s) retry(%s/%s)"), (this._settings || {}).isInitiator, this._reconnectAttempt, this._reconnectAttemptsThreshold.length);
      if (needReconnect) {
        this.close();
        this._reconnectAttempt = this._reconnectAttempt + 1;
        this._peer = this._createPeer();
      }
      return this;
    });
    _defineProperty(this, "isDestroy", () => this._peer && !this._peer.destroyed);
    _defineProperty(this, "replaceTrack", (toAdd, toRemove, stream) => this._peer.replaceTrack(toAdd, toRemove, stream));
    _defineProperty(this, "addTrack", (track, stream) => this._peer.addTrack(track, stream));
    _defineProperty(this, "getId", () => (this.getPeer() || {})._id);
    _defineProperty(this, "fetchStatsPerStream", stream => _callbacks.default.get('getPCStats')(this._peer._pc, stream, this._stats[stream.id]));
    _defineProperty(this, "getStatsPerStream", streamId => this._stats[streamId]);
    _defineProperty(this, "getStats", () => this._stats);
    _defineProperty(this, "getState", () => this._state);
    _defineProperty(this, "getNetworkQuality", () => this._networkQuality);
    _defineProperty(this, "getStateAt", () => new Date(this._stateAt).toISOString());
    _defineProperty(this, "getStreamChangedAt", () => this._streamChangedAt);
    _defineProperty(this, "monitorStream", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (stream) {
        var _config$webRTC2;
        var [audioTrack] = (0, _streams.getTracks)(stream, 'audio');
        var [videoTrack] = (0, _streams.getTracks)(stream, 'video');
        if (!audioTrack && !videoTrack) _this.stopMonitoringStream(stream.id);
        var hasAudio = (0, _streams.isTrackEnabled)(audioTrack);
        var hasVideoEnabled = (0, _streams.isTrackEnabled)(videoTrack);
        var hasCamera = (0, _streams.isCameraTrack)(videoTrack) && hasVideoEnabled;
        var hasScreen = (0, _streams.isScreenTrack)(videoTrack) && hasVideoEnabled;
        if ((0, _isNil.default)(_this._hasAudio[stream.id])) _this._hasAudio[stream.id] = hasAudio;
        if ((0, _isNil.default)(_this._hasVideo[stream.id])) _this._hasVideo[stream.id] = hasVideoEnabled;
        // this.log('monitoring in progress', stream.id, {
        //     hasAudio: this._hasAudio[stream.id],
        //     hasVideo: this._hasVideo[stream.id],
        // });

        // need to detect X times the video failed before doing anything
        if (!hasVideoEnabled && _this._hasVideo[stream.id] !== hasVideoEnabled) {
          if (!_this._hasVideoAttempts[stream.id]) _this._hasVideoAttempts[stream.id] = 0;
          if (_this._hasVideoAttempts[stream.id] < _config.default.webRTC.videoFailedAttempts) {
            _this._hasVideoAttempts[stream.id]++;
            // reset `hasVideo` to avoid streamChange
            hasVideoEnabled = _this._hasVideo[stream.id];
          }
        }
        var streamChanged = _this._hasAudio[stream.id] !== hasAudio || _this._hasVideo[stream.id] !== hasVideoEnabled;
        if (streamChanged) {
          if (streamChanged && _this._hasVideo[stream.id] !== hasVideoEnabled) {
            _this._hasVideo[stream.id] = hasVideoEnabled;
            delete _this._hasVideoAttempts[stream.id];
          }
          _this._hasAudio[stream.id] = hasAudio;
          _this.log('monitoring stream changed', {
            id: stream.id,
            streamChanged,
            hasAudio,
            hasVideoEnabled,
            hasCamera,
            hasScreen
          });
          _this._streamChangedAt = Date.now();
          _callbacks.default.get('dispatch')(actions.onPeerConnectionStreamChange({
            _entity: _this.__entity,
            token: _this._token,
            _client: _this.__client,
            hasAudio,
            hasCamera,
            hasScreen
          }));
        }
        if (_config.default !== null && _config.default !== void 0 && (_config$webRTC2 = _config.default.webRTC) !== null && _config$webRTC2 !== void 0 && _config$webRTC2.streamStatsInterval) {
          var _this$_stats$stream$i, _this$_stats$stream$i2, _config$webRTC3;
          if (!_this._stats[stream.id]) {
            _this._stats[stream.id] = {};
          }

          // Why i don't need to fetch stats
          if (_this._stats[stream.id].lock) return;
          if (_this._state !== _constants.WEBRTC_STATES.CONNECTED) return;
          if (!_this._peer) return;
          if (!_callbacks.default.isExist('getPCStats')) return;
          var isAudioEnabled = (0, _streams.isTrackEnabled)(audioTrack, false);
          var isAudioBitrateExpected = isAudioEnabled && (0, _isNil.default)((_this$_stats$stream$i = _this._stats[stream.id].audio) === null || _this$_stats$stream$i === void 0 ? void 0 : _this$_stats$stream$i.bitrate);
          var isVideoEnabled = (0, _streams.isTrackEnabled)(videoTrack, false);
          var isVideoBitrateExpected = isVideoEnabled && (0, _isNil.default)((_this$_stats$stream$i2 = _this._stats[stream.id].video) === null || _this$_stats$stream$i2 === void 0 ? void 0 : _this$_stats$stream$i2.bitrate);
          if (!_this._stats[stream.id].createdAt || isAudioBitrateExpected || isVideoBitrateExpected || Date.now() - _this._stats[stream.id].createdAt > (_config.default === null || _config.default === void 0 || (_config$webRTC3 = _config.default.webRTC) === null || _config$webRTC3 === void 0 ? void 0 : _config$webRTC3.streamStatsInterval)) {
            _this._stats[stream.id].lock = true;
            try {
              var stats = yield _this.fetchStatsPerStream(stream);
              if (stats.audio || stats.video) {
                var _stats$audio, _stats$video, _stats$audio2, _stats$video2;
                var rtt = (stats === null || stats === void 0 || (_stats$audio = stats.audio) === null || _stats$audio === void 0 ? void 0 : _stats$audio.googRtt) || (stats === null || stats === void 0 || (_stats$video = stats.video) === null || _stats$video === void 0 ? void 0 : _stats$video.googRtt);
                var networkQuality;

                // sender
                if (rtt) {
                  _this._rtt.push(rtt);
                  _this._rtt = _this._rtt.slice(-20);
                  var meanRtt = Math.round((0, _mean.default)(_this._rtt));
                  networkQuality = _constants2.QUALITY.LOW;
                  if (meanRtt < 50) {
                    networkQuality = _constants2.QUALITY.PERFECT;
                  } else if (meanRtt < 120) {
                    networkQuality = _constants2.QUALITY.HIGH;
                  } else if (meanRtt < 200) {
                    networkQuality = _constants2.QUALITY.MEDIUM;
                  }
                }
                // for receiver
                var ratio;
                if (!(0, _isNil.default)(stats === null || stats === void 0 || (_stats$audio2 = stats.audio) === null || _stats$audio2 === void 0 ? void 0 : _stats$audio2.packetsLostRatio)) {
                  ratio = stats.audio.packetsLostRatio;
                }
                if (!(0, _isNil.default)(stats === null || stats === void 0 || (_stats$video2 = stats.video) === null || _stats$video2 === void 0 ? void 0 : _stats$video2.packetsLostRatio) && stats.video.packetsLostRatio > ratio) {
                  ratio = stats.video.packetsLostRatio;
                }
                if (!(0, _isNil.default)(ratio)) {
                  if (ratio < 1) {
                    networkQuality = _constants2.QUALITY.PERFECT;
                  } else if (ratio < 2) {
                    networkQuality = _constants2.QUALITY.HIGH;
                  } else if (ratio < 5) {
                    networkQuality = _constants2.QUALITY.MEDIUM;
                  } else if (ratio >= 20) {
                    networkQuality = _constants2.QUALITY.LOW;
                  }
                }
                if (networkQuality) _this._networkQuality = networkQuality;
                var firstStats = stats.audio && !_this._stats[stream.id].audio || stats.video && !_this._stats[stream.id].video;
                _this._stats[stream.id] = _objectSpread(_objectSpread({}, _this._stats[stream.id]), stats);
                _callbacks.default.get('dispatch')(actions.onPeerConnectionStats({
                  _entity: _this.__entity,
                  token: _this._token,
                  _client: _this.__client,
                  stats,
                  isVideoEnabled,
                  isAudioEnabled,
                  streamId: stream.id,
                  firstStats
                }));
              }
            } catch (e) {
              _this.warn('@@@@@@@ statsExcepted error', e);
            } finally {
              delete _this._stats[stream.id].lock;
              _this._stats[stream.id].createdAt = Date.now();
            }
          }
        }
      });
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "startMonitoringStream", stream => {
      var _config$webRTC4, _config$webRTC5;
      if (!(_config.default !== null && _config.default !== void 0 && (_config$webRTC4 = _config.default.webRTC) !== null && _config$webRTC4 !== void 0 && _config$webRTC4.streamMonitoringInterval) || !stream || this._settings.isTrashable) {
        return;
      }
      this.stopMonitoringStream(stream.id);
      this.monitorStream(stream);
      this._monitoringInterval[stream.id] = setInterval(() => this.monitorStream(stream), _config.default === null || _config.default === void 0 || (_config$webRTC5 = _config.default.webRTC) === null || _config$webRTC5 === void 0 ? void 0 : _config$webRTC5.streamMonitoringInterval);
    });
    _defineProperty(this, "stopMonitoringStream", streamId => {
      this.log('stopMonitoringStream', streamId);
      if (this._monitoringInterval[streamId]) {
        clearInterval(this._monitoringInterval[streamId]);
        delete this._monitoringInterval[streamId];
      }
    });
    _defineProperty(this, "stopMonitoringAllStreams", () => {
      this.log('stopMonitoringAllStreams');
      (0, _map.default)(this._monitoringInterval, (interval, streamId) => {
        if (interval) {
          clearInterval(interval);
          delete this._monitoringInterval[streamId];
        }
      });
    });
    this._settings = _settings;
    this._token = _token;
    this.__entity = _entity;
    this.__client = _client;
    this._profile = profile;
    this._peer = this._createPeer();
  }
}
class PeerManager {
  constructor() {
    var _this2 = this;
    _defineProperty(this, "_peers", {});
    _defineProperty(this, "getStateInfos", function () {
      var {
        _entity,
        _client
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!_entity || !_client) return undefined;
      var peers = _this2.getPeer({
        _entity,
        _client
      });
      var info;
      if (peers) {
        (0, _map.default)(peers, peer => {
          if (peer.isTrashable === false) {
            info = {
              state: peer.pc.getState(),
              stateAt: peer.pc.getStateAt(),
              quality: peer.pc.getNetworkQuality()
            };
          }
        });
      }
      return info;
    });
    _defineProperty(this, "getStats", function () {
      var {
        _entity,
        _client,
        token,
        id: streamId
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!_entity || !_client || !token) return {};
      var peer = _this2.getPeer({
        _entity,
        _client,
        token
      });
      if (!peer) return {};
      return peer.pc.getStatsPerStream(streamId);
    });
    _defineProperty(this, "getStreamChangedAt", function () {
      var {
        _entity,
        _client
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!_entity || !_client) return undefined;
      var peers = _this2.getPeer({
        _entity,
        _client
      });
      var streamsChangedAt = [];
      if (peers) {
        (0, _map.default)(peers, peer => {
          streamsChangedAt.push(peer.pc.getStreamChangedAt());
        });
      }
      return (0, _sortBy.default)(streamsChangedAt).slice(-1)[0];
    });
    _defineProperty(this, "getPeer", _ref3 => {
      var {
        _entity,
        _client,
        token
      } = _ref3;
      var peerKey = "".concat(_entity, "-").concat(_client);
      if (token) {
        var _this$_peers$peerKey, _this$_peers;
        return ((_this$_peers$peerKey = this._peers[peerKey]) === null || _this$_peers$peerKey === void 0 ? void 0 : _this$_peers$peerKey[token]) || ((_this$_peers = this._peers["".concat(_entity, "-").concat(_constants.JANUS_CLIENT_ID)]) === null || _this$_peers === void 0 ? void 0 : _this$_peers[token]); // uniq peer
      }

      return this._peers[peerKey]; // collection with multiple peers
    });
    _defineProperty(this, "getPeers", () => this._peers);
    _defineProperty(this, "addPeer", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(function* (_ref4) {
        var {
          _client,
          profile,
          token,
          _entity,
          settings
        } = _ref4;
        var peerKey = "".concat(_entity, "-").concat(_client);
        var peerConfig = {
          token,
          settings,
          _client,
          profile,
          _entity
        };
        var pc = new Peer(peerConfig);
        pc.log('addPeer', {
          _client,
          profile,
          token,
          _entity,
          settings
        });
        if (!_this2._peers[peerKey]) {
          _this2._peers[peerKey] = {};
        }
        _this2._peers[peerKey][token] = _objectSpread(_objectSpread({}, peerConfig), {}, {
          isTrashable: (settings === null || settings === void 0 ? void 0 : settings.isTrashable) === true,
          pc
        });
        return _this2._peers[peerKey][token];
      });
      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }());
    // Avoid infinite PC_RESET loop by removing same previous peer.
    _defineProperty(this, "removePreviousPeer", _ref6 => {
      var {
        _client,
        _entity,
        profile,
        type,
        previousToken
      } = _ref6;
      var peerKey = "".concat(_entity, "-").concat(_client);
      var peer;
      if (previousToken) {
        peer = this.getPeer({
          _client,
          _entity,
          token: previousToken
        });
      } else {
        if (this._peers[peerKey]) {
          peer = Object.values(this._peers[peerKey]).find(p => {
            var _p$profile, _p$pc;
            return (p === null || p === void 0 || (_p$profile = p.profile) === null || _p$profile === void 0 ? void 0 : _p$profile.key) === (profile === null || profile === void 0 ? void 0 : profile.key) && (p === null || p === void 0 || (_p$pc = p.pc) === null || _p$pc === void 0 || (_p$pc = _p$pc.getPeer()) === null || _p$pc === void 0 || (_p$pc = _p$pc._pc) === null || _p$pc === void 0 || (_p$pc = _p$pc.localDescription) === null || _p$pc === void 0 ? void 0 : _p$pc.type) === type;
          });
        }
      }
      if (peer) {
        this.removePeer(peer);
      }
    });
    _defineProperty(this, "removePeer", _ref7 => {
      var {
        _client,
        _entity,
        token
      } = _ref7;
      var peerKey = "".concat(_entity, "-").concat(_client);
      var peer = this.getPeer({
        _client,
        _entity,
        token
      });
      if (peer !== null && peer !== void 0 && peer.pc) peer.pc.close();
      if (this._peers[peerKey]) {
        delete this._peers[peerKey][token];
        if (!Object.entries(this._peers[peerKey]).length) delete this._peers[peerKey];
      }
    });
    _defineProperty(this, "removePeers", _ref8 => {
      var {
        _client,
        _entity
      } = _ref8;
      var peers = this.getPeer({
        _client,
        _entity
      });
      (0, _map.default)(peers, (peer, token) => this.removePeer({
        _client,
        _entity,
        token
      }));
    });
    _defineProperty(this, "getPeersByEntity", _entity => (0, _filter.default)(this._peers, (peers, peerKey) => peerKey.startsWith("".concat(_entity, "-"))));
    _defineProperty(this, "removePeersByEntity", _entity => this.getPeersByEntity(_entity).forEach(peers => {
      (0, _map.default)(peers, _ref9 => {
        var {
          _client,
          token
        } = _ref9;
        return this.removePeer({
          _client,
          _entity,
          token
        });
      });
    }));
    _defineProperty(this, "getCurrentEntities", () => {
      var _entities = new Set();
      (0, _map.default)(this._peers, peers => {
        (0, _map.default)(peers, peer => _entities.add(peer._entity));
      });
      return [..._entities];
    });
    _defineProperty(this, "broadcast", (_entity, func) => {
      this.getPeersByEntity(_entity).map(peers => (0, _map.default)(peers, func));
    });
    _defineProperty(this, "addTrack", _ref10 => {
      var {
        _entity,
        newTrack
      } = _ref10;
      logger.log('addTrack ', {
        _entity,
        newTrack
      });
      this.broadcast(_entity, (peer, peerName) => {
        var pc = peer.pc.getPeer();
        pc.log('addTrack:broadcast:pc ', {
          peer,
          peerName
        });
        var stream = pc.streams[0];
        if (stream) {
          pc.log('addTrack:broadcast:pc:addTrack ', {
            newTrack,
            stream
          });
          pc.addTrack(newTrack, stream);
        } else {
          pc.warn('addTrack:broadcast:pc:addtrack:skip ', pc.streams);
        }
      });
    });
    _defineProperty(this, "replaceTrack", _ref11 => {
      var {
        _entity,
        newTrack
      } = _ref11;
      logger.log('replaceTrack ', {
        _entity,
        newTrack
      });
      this.broadcast(_entity, (peer, peerName) => {
        var pc = peer.pc;
        var simplePeer = pc.getPeer();
        if (pc && simplePeer instanceof _simplePeer.default) {
          pc.log('replaceTrack:broadcast:pc ', {
            peer,
            peerName
          });
          var stream = simplePeer.streams[0];
          if (stream) {
            var {
              kind
            } = newTrack;
            var [oldTrack] = (0, _streams.getTracks)(stream, kind);
            pc.log('replaceTrack:broadcast:pc:replaceTrack ', {
              kind,
              oldTrack,
              newTrack,
              stream
            });
            if (oldTrack) {
              pc.replaceTrack(oldTrack, newTrack, stream);
            }
          } else {
            pc.warn('replaceTrack:broadcast:pc:replaceTrack:skip no stream', simplePeer.streams);
          }
        } else {
          pc.warn('replaceTrack:broadcast:pc:replaceTrack:skip no linked PC');
        }
      });
    });
    this._peers = {};
  }
}
var _default = exports.default = (0, _debug.addDebugAttribute)(new PeerManager(), 'PeerManager');
module.exports = exports.default;